import axios from "axios";
import { Planning, PlanningSchema, UpsertNewPlanningDTO } from "../types/planning";
import { toCamelCase, toSnakeCase } from "../utils/objectHelper";

export const PlanningTransporter = {
    save: async (object: Planning, id: number | undefined | null): Promise<Planning> => {
        const response = await axios.request<Planning>({
            method: "put",
            url: `/planning/${id}`,
            data: toSnakeCase({
                ...object,
                moneySiteId: object.moneySite.id,
                projectManagerId: object.projectManager.id,
            }),
        });

        return response.data;
    },

    saveNew: async (plans: Array<UpsertNewPlanningDTO>): Promise<Array<Planning>> => {
        const response = await axios.request<Array<Planning>>({
            method: "post",
            url: "/planning",
            data: toSnakeCase({ planning: [...plans] }),
        });

        return response.data;
    },

    edit: async (plan: UpsertNewPlanningDTO): Promise<Planning> => {
        const response = await axios.request<Planning>({
            method: "put",
            url: `/planning/edit/${plan.id}`,
            data: toSnakeCase(plan),
        });

        return response.data;
    },

    listAllNoSetByManager: async (): Promise<Array<Planning>> => {
        const { data } = await axios.request<Array<Planning>>({
            method: "get",
            url: "/planning/noSetByManager",
        });
        return data.map((current) =>
            PlanningSchema.cast(toCamelCase(current), { stripUnknown: true })
        );
    },

    checkNetlinkingNumberOfKeyword: async (
        keywords: { [thematic: number]: string[] },
        planningId: number
    ): Promise<{ ok: boolean; error: string }> => {
        const { data } = await axios.request<{ ok: boolean; error: string }>({
            method: "post",
            url: "/planning/checkNetlinkingNumberOfKeyword",
            data: { keywords, planningId },
        });
        return data;
    },

    findByMoneySiteId: async (moneySiteId: number): Promise<Array<Planning>> => {
        const { data } = await axios.request<Array<Planning>>({
            method: "get",
            url: `/planning/findByMoneySite?moneySiteId=${moneySiteId}`,
        });
        //todo add PlanningSchema.cast()
        return data.map((current) => toCamelCase(current));
    },

    toggleActive: async (planningId: number): Promise<void> => {
        const action = "toggleActive";
        await axios.patch(`/planning/${planningId}/actions/${action}`);
    },

    formTransformer: (object?: Planning): UpsertNewPlanningDTO | null => {
        if (!object) {
            return null;
        }

        return {
            ...object,
            id: object.id,
            moneySiteId: object.moneySite.id,
            price: object.price || null,
            projectManagerId: object.projectManager.id,
        };
    },
};
